









































import Vue, { PropOptions } from 'vue';
import {NOC, moment} from '@/class';

import GadgetFrame, {IFrame} from './EditerGadgetFrameV3.vue';
// import SelectBox, {IOption} from '@/components/util/SelectBoxV3.vue';
import SelectBox, {IOption} from '@/components/util/SelectBoxV4.vue';

// Datepicker
import DatePicker from 'vuejs-datepicker';
import {ja} from 'vuejs-datepicker/dist/locale';

// 通信
import API from '@/api/common';
import * as models from '@/class/models/views/graph';

// const GRAPH_HW = 248;

export default Vue.extend({
  name: 'CSVDLGadgetV3',
  components: { GadgetFrame, SelectBox, DatePicker },
  props: {
    baseFrameData: Object as PropOptions<IFrame>,
    gadgetData: Object as PropOptions<models.IGadget>,
    initialValue: String,
  },
  data() {
    return {
      csvtitle: 'CSVダウンロード',
      error: false,
      preDate: '',
      preDateTo: '',
      date: moment.funcGetFirstDayOfMonth(),
      dateto: moment.fncGetYesterDay(),
      ct1Options: [NOC.SELECT.NOSELECT_LONG] as IOption[],
      ct1Value: 0,
      ct1Back: '[]',
      ct1ValueBack: 0,
      ct1Flag: false,
      downloading: false,
      dummyMaterials: {
        target: [ NOC.GRAPH.MATERIAL.V2.MATERIAL[0], NOC.GRAPH.MATERIAL.V2.MATERIAL[4]] as any[],
        measure: [ NOC.GRAPH.MATERIAL.V2.MATERIAL[5] ] as any[],
        dimension: [ NOC.GRAPH.MATERIAL.V2.MATERIAL[11] ] as any[],
        selectGraph: { key: '', value: 'radar-chart', id: 0 },
      } as any,
      DatePickerDate: 'yyyy. M. d',
      ja,
    };
  },
  computed: {
    dynamicId() {
      return  String(Math.random());
    },
    frameData() {
      const obj: IFrame = JSON.parse(JSON.stringify(this.baseFrameData));
      obj.sample = true;
      return obj;
    },
  },
  async mounted() {
    // if (this.gadgetData.data.values.date) {
    //   this.date = this.gadgetData.data.values.date;
    // }
    // if (this.gadgetData.data.values.dateto) {
    //   this.dateto = this.gadgetData.data.values.dateto;
    // } else {
    //   this.dateto = this.date;
    // }

    // 本日が1日なら前月の初日~先月末までの範囲を絞り込む
    const today = new Date().getDate();
    if (today === 1) {
      this.date = moment.funcGetFirstDayOfMonth(moment.fncGetYesterDay(this.date));
    }

    const api = new API();
    const res = await api.post<any, IOption[]>('gadget/ct1', NOC.GRAPH.MATERIAL.V2.MATERIAL[0]);
    if (res.result) {
      if (res.data.length > 0) {
        this.ct1Options = this.ct1Options.concat(res.data);
        this.ct1Flag = true;
      }
    }
    this.setData();
  },
  // created() {
  //  this.triggerEvent();
  // },
  methods: {
    changeValue(value: any) {
      this.$emit('setValues', [this.gadgetData, {
        setData: value,
      } as models.IValues]);
    },
    atherAction() {
      this.$emit('ather');
    },
    onShowDetail() {
      if (this.ct1Value.toString() === '0' || this.baseFrameData.cover) {
        return;
      }
      const values = {
        setData: this.ct1Value.toString(),
        date: this.date,
        dateto: this.dateto,
      } as models.IValues;
      this.setData();
      this.$emit('showDetail', values);
    },
    class_disabled() {
      return {btn_disabled: this.ct1Value.toString() === '0'};
    },
    async onDlCSV() {
      if (this.ct1Value.toString() === '0' || this.baseFrameData.cover || this.downloading) {
        return;
      }
      this.downloading = true;
      this.setData();
      const api = new API();
      /*
      const requestData = {
        materials: this.dummyMaterials,
        page: 0,
        csv: true,
      };
      */
      const requestData = {
        values: {
          setData: this.ct1Value.toString(),
          date: this.date,
          dateto: this.dateto,
        } as models.IValues,
        page: 0,
        csv: true,
      };
      const res = await api.post<any, any>('gadget/basic_graph/detail', requestData);
      this.downloading = false;
      if (res.result) {
        // console.log(res.data);
      }
    },
    setData() {
      (this as any).dummyMaterials.target[0].value = this.ct1Value;
      // console.log(this.date);
      this.dummyMaterials.target[1].value = this.date;
    },
    isDateError() {
      return new Date(this.date) > new Date(this.dateto);
    },
  },
  directives: {
    DatePicker,
  },
  watch: {
    date(to) {
      // YYYY-MM-DDの正規表現
      const dateReg = '^[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$';
      const setValue = (date: string) => {
        this.date = moment.fncChangeDateToInputForm(new Date(date));
        this.$emit('setValues', [this.gadgetData, { setData: this.gadgetData.data.values.setData, date: this.date, dateto: this.dateto } as models.IValues]);
      };

      if (this.preDate !== '' && this.preDate !== this.date) {
        setValue(this.date);
      }

      // 正規表現とマッチしなければ日付のフォーマットを行いvalueをセットする
      const isMatch = String(this.date).match(dateReg) ? true : false;
      if (!isMatch) {
        setValue(this.date);
      }
      this.preDate = this.date;
    },
    dateto(to) {
      // YYYY-MM-DDの正規表現
      const dateReg = '^[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$';

      const setValue = (dateto: string) => {
        this.dateto = moment.fncChangeDateToInputForm(new Date(dateto));
        this.$emit('setValues', [this.gadgetData, { setData: this.gadgetData.data.values.setData, date: this.date, dateto: this.dateto } as models.IValues]);
      };

      if (this.preDateTo !== '' && this.preDateTo !== this.dateto) {
        setValue(this.dateto);
      }

      // 正規表現とマッチしなければ日付のフォーマットを行いvalueをセットする
      const isMatch = String(this.dateto).match(dateReg) ? true : false;
      if (!isMatch) {
        setValue(this.dateto);
      }
      this.preDateTo = this.dateto;
    },
  },
});
